import { ClampedText } from "~/common/components/ui/typography";

interface FeedNoteProps {
  title: string;
  text: string;
}
export const FeedNote = ({ text, title }: FeedNoteProps) => {
  return (
    <div className="flex flex-col gap-1 overflow-auto whitespace-pre-wrap break-all rounded-md bg-neutral-100 p-4 text-sm text-gray-10 first-letter:uppercase">
      <p className="font-semibold">{title}</p>
      <ClampedText text={text} lines={3} className="font-medium" />
    </div>
  );
};
